import { useMutation } from '@tanstack/react-query'
import { postPropertyShare } from "./api"

export const usePostPropertyShare = () => {
  return useMutation({
    queryKey: ['post-property-share'],
    mutationFn: ({slug, data}) => postPropertyShare(slug, data),
  })
}